import React from 'react';
import { JSONPathTester } from '../components/jsonpath-tester/JSONPathTester';

export const JSONPathTesterPage: React.FC = () => {
  return (
    <div className="page-container">
      <JSONPathTester />
    </div>
  );
};
